<!-- ALTERACAO NAS ALIQUOTAS DAS ADICOES DA DI -->

<script>
import { SysVars } from '../main';
import { arr, calcDesconto } from '../shared/numbers'
import { getText, formatDate, formatValue } from '../shared/utils'

export default {
    props: {
        params: {}, //RECEBE 3 OBJETOS: DI, DIIT (itens) E DIAD (adicoes)
    },

    components: {

    },

    data () {
        return {
            //entidades
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [],  //armazena as mensagens de validacao da nf apos a gravacao
        }
    },

    computed: {
        di: function () {
            return this.params.di
        },

        diad: function () {
            return this.params.diad
        },

        diit: function () {
            return this.params.diit
        },

   },

    filters: {
        format: function (value, decimals) {
            return formatValue(value, decimals)
        },
    },

    methods: {
        showAliq: function(value) {
          return (value.aii && value.aii > 0) || (value.aipi && value.aipi > 0) || (value.apis && value.apis > 0) || (value.acofins && value.acofins > 0)
        },


        data (value) {
            return formatDate(value)
        },

        handleSalvar () {
            //ATUALIZA AS ALIQUOTAS DOS ITENS (OBJETO DIIT) COM AS ALIQUOTAS INFORMADAS NA ADICAO (OBJETO DIAD)
            for (let i = 0; i < this.diit.length; i++) {
                let lAdicao = {}
                for (let x = 0; x < this.diad.length; x++) {
                    if (this.diad[x].nadicao == this.diit[i].nadicao) {
                        lAdicao = this.diad[x]
                    }
                }
                //atualiza as aliquotas da adicao no item
                this.diit[i].aicm = lAdicao.aicm
                this.diit[i].ricm = lAdicao.ricm
                this.diit[i].mva = lAdicao.mva
                this.diit[i].sticm = lAdicao.sticm
                this.diit[i].motdesicm = lAdicao.motdesicm
            }
            this.$emit('save')
        },

        closeForm () {
            this.$emit('closeform')
        },

    },

    watch: {

    },

    created () {
        this.$nextTick(function () {
          jQuery('[data-toggle="tooltip"]').tooltip()
        })

        this.$scrollTo(0)
    }

}

</script>

<template>
    <div>
        <div class="row mb-3">
            <div class="col-md-6 col-12">
                <h4 class="def-title"> Alteração de Alíquotas nas Adições</h4>
            </div>
            <div class="col-md-6 col-12">
                <div class="float-right">
                    <v-button label="Retornar" title="" icon="fa-arrow-left" @click="closeForm"></v-button>
                    <v-button label="Salvar" title="" icon="fa-download" :nb-btdef="true" @click="handleSalvar"></v-button>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-2 col-2">
                <v-label label="Número"></v-label><br>
                <span class="lbl">{{ di.numerodi }}</span>
            </div>
            <div class="col-md-2 col-2">
                <v-label label="Data"></v-label><br>
                <span class="lbl">{{ data(di.datadesemb) }}</span>
            </div>
            <div class="col-md-4 col-4">
                <v-label :metadata-field="metadata.di.nomefornecedor"></v-label><br>
                <span class="lbl">{{ di.nomefornecedor }}</span>
            </div>
        </div>

        <!-- ADICOES E ALIQUOTAS DE ICMS -->
        <div>
            <label-title title="Adições"></label-title>
            <div class="mainbox" v-for="(adicao, index) in diad" :key="index">
                <div class="mark-green"></div>
                <div class="box">
                    <div class="row">
                        <div class="col-md-2 col-2">
                            <v-label class="lbl-edit" :metadata-field="metadata.diad.nadicao"></v-label><br>
                            <span class="data-list">{{ adicao.nadicao }}</span>
                        </div>
                        <div class="col-md-2 col-2">
                            <v-label class="lbl-edit" :metadata-field="metadata.diad.ncm"></v-label><br>
                            <span class="data-list">{{ adicao.ncm }}</span>
                        </div>
                        <div class="col-md-2 col-2">
                            <v-label class="lbl-edit" :metadata-field="metadata.diad.pliq"></v-label><br>
                            <span class="data-list">{{ adicao.pliq | format(2) }}</span>
                        </div>
                        <div class="col-md-1 col-2" v-if="showAliq(adicao)">
                            <v-label class="lbl-edit" :metadata-field="metadata.diad.aii"></v-label><br>
                            <span class="data-list">{{ adicao.aii | format(2) }}</span>
                        </div>
                        <div class="col-md-1 col-2" v-if="showAliq(adicao)">
                            <v-label class="lbl-edit" :metadata-field="metadata.diad.aipi"></v-label><br>
                            <span class="data-list">{{ adicao.aipi | format(2) }}</span>
                        </div>
                        <div class="col-md-1 col-2" v-if="showAliq(adicao)">
                            <v-label class="lbl-edit" :metadata-field="metadata.diad.apis"></v-label><br>
                            <span class="data-list">{{ adicao.apis | format(2) }}</span>
                        </div>
                        <div class="col-md-1 col-2" v-if="showAliq(adicao)">
                            <v-label class="lbl-edit" :metadata-field="metadata.diad.acofins"></v-label><br>
                            <span class="data-list">{{ adicao.acofins | format(2) }}</span>
                        </div>
                    </div>
                    <div class="row">
                        <form-field v-model="adicao.cfop" type="select2" col="2" :metadata="metadata.diad.cfop"
                                :select2="{entity: 'cfop/entradas', minlength: 0}"></form-field>
                        <form-field v-model="adicao.sticm" type="select2" col="2" :metadata="metadata.diad.sticm"
                            name="sticm" :v-errors="errors" v-validate="metadata.diad.sticm.validator"></form-field>
                        <!-- <div class="col-md-2 col-3">
                            <v-label class="lbl-edit" :metadata-field="metadata.diad.vtotal"></v-label><br>
                            <span class="data-list">{{ adicao.vtotal | format(2) }}</span>
                        </div> -->
                        <form-field v-model="adicao.aicm" type="value" col="2" :metadata="metadata.diad.aicm"></form-field>
                        <form-field v-model="adicao.ricm" type="value" col="2" :metadata="metadata.diad.ricm"></form-field>
                        <form-field v-model="adicao.mva" type="value" col="2" :metadata="metadata.diad.mva"></form-field>
                        <!-- <form-field v-model="adicao.motdesicm" type="select2" col="4" :metadata="metadata.diad.motdesicm"></form-field> -->
                    </div>
                </div>
            </div>
            <div>
                <br>
                <div class="row">
                    <div class="col-md-12 col-12">
                        <div class="float-right">
                            <v-button label="Retornar" title="" icon="fa-arrow-left" @click="closeForm"></v-button>
                            <v-button label="Salvar" title="" icon="fa-download" :nb-btdef="true" @click="handleSalvar"></v-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- FIM ADICOES E ALIQUOTAS DE ICMS -->

    </div>
</template>



// WEBPACK FOOTER //
// src/forms/nfimport-adicao-form.vue